export default {
    permissionLoading: state => state.permissionLoading,
    permissionsListLoading: state => state.permissionsListLoading,
    permissionsList: state => state.permissionsList,
}